<template lang="html">
    <header class="header-sidebar ui sidebar vertical menu visible">
        <img class="logo" src="../../static/croud-logo.svg" @click="goHome()" />
        <nav>
            <template v-for="route in routes">
                <template v-if="route.name || route.title">
                    <template v-if="route.children">
                        <router-link tag="a" :to="{ name: route.children[0].name, params: {} }" class="item" active-class="active" exact>
                            {{route.title || route.name}}
                        </router-link>
                        <div v-show="catagoryOpen(route)" v-for="child in order(route.children)" class="submenu">
                            <router-link tag="a" :to="{ name: child.name, params: {} }" class="item" active-class="active">
                                {{child.name}}
                            </router-link>
                        </div>
                    </template>
                    <template v-else>
                        <router-link tag="a" :to="{ name: route.name || undefined, params: {} }" class="item" active-class="active" exact>
                            {{route.title || route.name}}
                        </router-link>
                    </template>
                </template>
            </template>
        </nav>
        <div class="bottom-menu">
            <a href="https://croudsupport.github.io/Croud-Style-Guide/technical/"><button class="ui button mini basic yellow">Open Tech Docs</button></a>
        </div>
    </header>
</template>

<script>
import _ from 'lodash'

export default {
    data() {
        return {
            routes: this.$router.options.routes,
        }
    },
    methods: {
        catagoryOpen(route) {
            const currentCatagory = this.$route.path.split('/')[1]
            const routeCatagory = route.path.split('/')[1]

            return currentCatagory === routeCatagory
        },
        goHome() {
            this.$router.push({ name: 'introduction-default' })
        },
        order(children) {
            return _.sortBy(children.slice(1), 'name')
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../resources/sass/variables/all.scss';

    .ui.sidebar.menu {
        background-color: $croud-colour-header;

        .item {
            color: $croud-colour-white;
            font-size: $croud-font-size-small;
            text-transform: capitalize;

            &.active {
                
                &:hover {
                    color: $croud-colour-grey;
                }
            }
        }

        .submenu {

            .item {
                padding-left: 2.5em;
                font-weight: 300;
            }
        }

        .bottom-menu {
            position: absolute;
            bottom: 0;
            .ui.button {
                margin: .8rem;
            }
        }
    }

    .logo {
        width: 50%;
        display: block;
        margin: 2em auto;
        height: auto;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// Navigation.vue?118d1a3c